function actionOnClick(e) {
    const target = e.target;
    const action = target.getAttribute('data-action');

    switch (action) {
        case 'onetrust-manage':
            window.Optanon.ToggleInfoDisplay();
            break;
    }
}

export function initButtonActions() {
    const ctas = document.querySelectorAll('[data-action]');

    ctas.forEach(cta => {
        cta.addEventListener('click', actionOnClick);
    });
}
